export function headerFunc() {
  // ハンバーガーメニュー実装
  $('.l-header__toggle-button').on('click', function() {
    $('.l-header__toggle-button').toggleClass('l-header__toggle-button--close');
    $('.l-header__nav').toggleClass('l-header__nav--open');
    $('.l-header__switch').toggleClass('l-header__switch--open');
    
    // メニューが開いている時はbodyのスクロールを無効にする
    if ($('.l-header__nav').hasClass('l-header__nav--open')) {
      $('body').addClass('is-menu-open');
    } else {
      $('body').removeClass('is-menu-open');
    }
  });

  // モバイルドロップダウンメニュー実装
  $('.l-header__nav__dropdown-sp').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('l-header__nav__dropdown-sp--open');
    $(this).next('.l-header__nav-sub__list').slideToggle(300);
  });
}